import { useTranslation } from 'react-i18next';
import { usePwaNav } from '../../contexts/PwaNavContext';
import type { VenueItem } from '../../types/feedMix';
import './VenueFeedCard.css';

interface Props {
  v: VenueItem;
}

export function VenueFeedCard({ v }: Props) {
  const { t } = useTranslation();
  const { navigate } = usePwaNav();

  const distance =
    v.distanceKm == null
      ? null
      : v.distanceKm < 1
        ? t('feed.distanceM', { n: Math.round(v.distanceKm * 1000) })
        : t('feed.distanceKm', { n: v.distanceKm.toFixed(1) });

  return (
    <button
      type="button"
      className="vfc-card"
      onClick={() => navigate(`/v/${v.slug}`)}
      aria-label={v.name}
    >
      <div className="vfc-cover">
        {v.coverImageUrl ? (
          <img className="vfc-img" src={v.coverImageUrl} alt="" loading="lazy" />
        ) : (
          <div className="vfc-fallback" aria-hidden />
        )}
        <div className="vfc-grad" aria-hidden />
        <span className="vfc-pill">{t('feed.venuePill', { defaultValue: 'ФУДКОРТ' })}</span>
      </div>
      <div className="vfc-body">
        <div className="vfc-name">{v.name}</div>
        <div className="vfc-meta">
          <span>
            {t('feed.venueRestaurantCount', {
              defaultValue: '{{n}} ресторанов',
              n: v.restaurantCount,
            })}
          </span>
          {distance && <span className="vfc-meta-dot" aria-hidden />}
          {distance && <span>{distance}</span>}
        </div>
      </div>
    </button>
  );
}
